import { render, staticRenderFns } from "./SidebarControlSelectList.vue?vue&type=template&id=2a3a7996&scoped=true"
import script from "./SidebarControlSelectList.vue?vue&type=script&lang=js"
export * from "./SidebarControlSelectList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a3a7996",
  null
  
)

export default component.exports